// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"196":"1bf8f2f2","256":"26287078","329":"5618e7d7","364":"7812c17e","825":"142c42e2","856":"ac641365"}[chunkId] + ".css";
};